<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q6kfX3/tc-custom/9781426831881.jpg?1738298778006" alt="This image is the cover for the book Code of Honor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Code of Honor
      </h1>
      <p class="bookDescription body article font2">
        <b>Her mission: to nurse the poor and serve God. His mission: to get her out of South America alive . . . A thrilling novel by the Carol Award finalist!</b><br/><br/>Get in, save the girl, and get back out. That was CHAIM agent Brice Whelan’s mission. But saving missionary/nurse Selena Carter might be more difficult than expected. Selena’s run-in with a drug cartel put the people in her care in danger. Yet the danger doesn’t end when Brice brings her home.<br/><br/>The counterfeit drugs have entered Georgia, and this time Selena isn’t about to run away. Brice’s mission hasn’t changed; he still needs to keep her safe. And that means staying by her side—whether she wants him there or not . . .<br/><br/><b>Praise for <i>New York Times</i>–bestselling author Lenora Worth</b><br/><br/>“The characters [are] warm and engaging . . . the faith element is always present, but is not heavy-handed or intrusive.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lenora Worth
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42ce531c